import { useMemo } from 'react';
import { Box, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PurchaseWidget from '../../../components/PurchaseWidget/PurchaseWidget';
import { SummaryDetails } from '../../../components/SummaryDetails';
import { STRINGS } from '../../../constants';
import { PURCHASE_WIDGET } from '../../../constants/strings';
import { CitysprintTextLogo } from './CitysprintTextLogo';
import { CitysprintSummaryQuoteDetails } from './CitysprintSummaryQuoteDetails';

export function CitysprintReviewBookSidebar({
  data,
  totalIncVatAmount,
  taxAmount,
  onBack,
  checkoutAmountString,
  getClientToken,
  onCheckout,
  checkoutDisabled,
  threeDSecure,
}) {
  const theme = useTheme();

  const price = useMemo(
    () => ({
      totalIncVatAmount,
      taxAmount,
    }),
    [totalIncVatAmount, taxAmount]
  );

  return (
    <Box
      sx={{
        position: 'sticky',
        top: `calc(var(--dpd-appbar-height, 0px) + ${theme.spacing(2)})`,
      }}
    >
      <Box
        sx={{
          pl: { xs: 3, md: 0 },
          pr: { xs: 3, md: 0 },
        }}
      >
        <SummaryDetails
          price={price}
          basketItemsWithPrice={[]}
          displayItemsPriceDetails={false}
          displayInsurance={false}
          belowSummaryContent={<CitysprintTextLogo />}
          itemsContent={<CitysprintSummaryQuoteDetails quote={data} />}
        />

        <Box sx={{ pb: 2 }}>
          <Button variant='outlined' fullWidth onClick={onBack}>
            {STRINGS.BACK}
          </Button>
        </Box>
        <PurchaseWidget
          getClientToken={getClientToken}
          handleCheckout={onCheckout}
          amount={checkoutAmountString}
          threeDSecure={threeDSecure}
          disabled={checkoutDisabled}
          sx={{ width: '100%' }}
        >
          {PURCHASE_WIDGET.CHECKOUT}
        </PurchaseWidget>
      </Box>
    </Box>
  );
}
